import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../../services/api.service';

@Injectable()
export class ShoppingCartService {
  constructor(
    private api: ApiService
  ) {}

  getCart(email): Observable<any> {
    return this.api.get('users/' + email + '/cart', {});
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/shopping-cart/shopping-cart.service.ts